import React, { useEffect, useState } from "react";
import axios from 'axios';
import './RelatedProducts.css';
import Item from '../Item/Item';

const RelatedProducts = ({ brand, category, type }) => {
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRelatedProducts = async () => {
            if (!category || !type) {
                setError('Missing required parameters');
                return;
            }

            const params = { category, type };
            if (category === 'sneakers' && brand) {
                params.brand = brand;
            }

            try {
                const response = await axios.get('/api/relatedproducts', { params });
                setRelatedProducts(response.data);
                setError(null);
            } catch (error) {
                setError('Error fetching related products');
                console.error('Error fetching related products:', error);
            }
        };

        fetchRelatedProducts();
    }, [brand, category, type]);

    // We only want to render the section if there are related products to show
    if (relatedProducts.length === 0 && !error) {
        return null; // Or return a loading spinner
    }

    return (
        // Changed to a <section> for better semantics
        <section className="related-products container">
            {/* The decorative <hr> has been removed. We'll style this in CSS. */}
            <h1>Related Products</h1>
            {error && <p className="error-message">{error}</p>}
            
            {/* The container for our new CSS Grid */}
            <div className="related-products__grid">
                {relatedProducts.slice(0, 4).map((item) => ( // Limit to 4 items for a nice grid
                    <Item
                        key={item.id}
                        id={item.id}
                        name={item.name}
                        image={item.image}
                        new_price={item.new_price}
                        old_price={item.old_price}
                    />
                ))}
            </div>
        </section>
    );
};

export default RelatedProducts;